import {
  ACTION_OUTBOUND_CLICK,
  CATEGORY_CLEAR_PARTNERSHIP,
} from 'utils/analytics/eventTypesConstants';
import { Button, Link, TITLE_TEXT, TockDialog, Typography } from 'omakase';
import { MobileNativeContext } from 'providers/withApplicationContext';
import {
  SafetyMeasureByCategory,
  safetyMeasureCategoryNameFromType,
  safetyMeasureIconFromTypeAndSize,
} from './safetyMeasuresUtils';
import {
  dialogIconStyle,
  dialogMeasureTitleStyle,
  dialogMeasuresSectionStyle,
  linkToClearEnclosingPStyle,
} from './safetyMeasuresCssDefs';
import OrphanProtected from 'components/OrphanProtected';
import React from 'react';

interface Props {
  measuresByCategory: SafetyMeasureByCategory[];
  onClose(): void;
  open: boolean;
}

export const SafetyMeasuresDialog: React.FunctionComponent<Props> = ({
  open,
  onClose,
  measuresByCategory,
}) => {
  const utmSource = React.useContext(MobileNativeContext).mobileNative ? 'App' : 'Web';
  const clearHref = `https://www.clearme.com/tock?utm_source=${utmSource}&utm_medium=Tock&utm_campaign=General`;
  const onClickClearLink = () =>
    window.analytics?.sendEvent(CATEGORY_CLEAR_PARTNERSHIP, ACTION_OUTBOUND_CLICK, clearHref);

  return (
    <TockDialog
      headingConfig={{
        left: { configType: 'title', title: 'Safety measures' },
        right: { configType: 'closeButton' },
      }}
      actionsContent={
        <Button onClick={onClose} variant="primary" fullWidth size="large">
          Close
        </Button>
      }
      type="fullScreen"
      aria-labelledby={TITLE_TEXT}
      open={open}
      onClose={onClose}
      showShadowWhenScrolled
    >
      {measuresByCategory.map(({ type, measures }) =>
        measures.length ? (
          <div key={type} css={dialogMeasuresSectionStyle}>
            <Typography css={dialogMeasureTitleStyle} variant="body01Strong">
              <span css={dialogIconStyle}>{safetyMeasureIconFromTypeAndSize(type, 'medium')}</span>
              {safetyMeasureCategoryNameFromType(type)}
            </Typography>
            <ul>
              {measures.map((measure) => (
                <Typography key={measure} variant="body02" component="li">
                  <OrphanProtected string={measure} />
                  {measure.includes('Proof of vaccination') ? (
                    <p css={linkToClearEnclosingPStyle}>
                      Use your vaccination card or{' '}
                      <Link onClick={onClickClearLink} href={clearHref}>
                        create your free digital vaccine card with CLEAR
                      </Link>
                    </p>
                  ) : null}
                </Typography>
              ))}
            </ul>
          </div>
        ) : null
      )}
    </TockDialog>
  );
};
